module.exports = __webpack_public_path__ + "static/media/crocodile(19).f594656e.PNG";